import React from 'react'
import Store from './src/Store'
import '@fontsource/noto-sans/400.css'
import '@fontsource/noto-sans/400-italic.css'
import '@fontsource/noto-sans/700.css'

export const wrapRootElement = ({ element }) => <Store>{element}</Store>
